import { GameVars } from "../GameVars";
import { GameConstants } from "../GameConstants";
import { Game } from "../Game";
import { GameManager } from "../managers/GameManager";

export class BootScene extends Phaser.Scene {

public static currentInstance: BootScene;

    public static onOrientationChange(): void {

        BootScene.currentInstance.time.addEvent({ delay: 100, callback: () => { 
            GameVars.scaleX = (GameConstants.GAME_WIDTH / GameConstants.GAME_HEIGHT) / (window.innerWidth / window.innerHeight);
            GameVars.scaleY = (GameConstants.GAME_HEIGHT / GameConstants.GAME_WIDTH) / (window.innerHeight / window.innerWidth);

            Game.currentInstance.scale.refresh();
        }, callbackScope: BootScene.currentInstance});
    }

    constructor() {

        super("BootScene");

        BootScene.currentInstance = this;
    }

    public preload(): void {

        this.load.image("bg", "assets/bg_tile.jpg");
    }

    public create(): void {

        GameVars.currentScene = this;

        this.add.text(0, 0, "ABCDEFG", {fontFamily: "Oswald-Medium", fontSize: "14px", color: "#FFFFFF"});

        if (this.sys.game.device.os.desktop && !GameConstants.FORCE_MOBILE) {

            GameVars.scaleX = 1;
            GameVars.scaleY = 1;

        } else {

            BootScene.currentInstance.game.scale.displaySize = BootScene.currentInstance.game.scale.parentSize;
            BootScene.currentInstance.game.scale.refresh();

            GameVars.scaleX = (GameConstants.GAME_WIDTH / GameConstants.GAME_HEIGHT) / (window.innerWidth / window.innerHeight);
            GameVars.scaleY = (GameConstants.GAME_HEIGHT / GameConstants.GAME_WIDTH) / (window.innerHeight / window.innerWidth);

            this.game.scale.on("orientationchange", BootScene.onOrientationChange, BootScene.currentInstance);
        }

        this.scene.setVisible(false);
        
        GameManager.init(BootScene.currentInstance.game); 
    }
}
